import { useRef } from "react";
import './ContactCss/Modal.css';

function Success(props){
    const modalRef = useRef();
    const modalOutClick = (e) => {
        if(modalRef.current === e.target){
            props.setVal('')
            move();
        }
    }

    const move = () => {
        window.location.reload(true);
    }

    return(
        <div className="valid" ref={modalRef} onClick={(e)=>{modalOutClick(e)}}>
            <div className="valid-modal">
                <div className="valid-modal-all">
                    <p className="valid-modal-font">
                        문의 주셔서 감사합니다.
                        <br></br>
                        빠른 시일 내에 답변 드리겠습니다.
                    </p>
                    <div className="valid-modal-button">
                        <button className="valid-modal-check" onClick={()=>{props.setVal(''); move();}}>
                            확인
                        </button>
                    </div>
                </div>
            </div>            
        </div>        
    )
}

export default Success;